import { occurrenceSchema, type Occurrence } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postRestore = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences/${id}/restore`, { method: 'POST' });

export const restoreOccurrence = async (id: string): Promise<Occurrence> =>
  occurrenceSchema.parse(await postRestore(id));
